import { COLOR, FONT_SIZE, FONT_WEIGHT } from "@dmm-com/rocket-web-ui-library";
import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const SpanText = styled.span<{ isHeading: boolean }>`
  vertical-align: middle;
  ${({ isHeading }) =>
    isHeading
      ? css`
          color: ${COLOR.GRAY900.code};
          font-weight: ${FONT_WEIGHT.BOLD};
        `
      : css`
          font-size: ${FONT_SIZE.S}px;
        `};
`;
